// extracted by mini-css-extract-plugin
export default {"impressionWrapper":"Impression_impressionWrapper__EXzpf","impressionContainer":"Impression_impressionContainer__BqG59"};